/**
 * @flow
 * @relayHash 1f66b3dcaa5372a49573100e1b3fcd90
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type TVShowEpisodeState = "available" | "hidden" | "%future added value";
export type TVShowEpisodeAddInput = {
  title: string,
  subtitle: string,
  description: string,
  shortDescription?: ?string,
  video?: ?string,
  videoFile?: ?string,
  preview?: ?string,
  show?: ?string,
  startDate: string,
  topics?: ?$ReadOnlyArray<?string>,
  endDate: string,
  state: TVShowEpisodeState,
  liveShow?: ?boolean,
  clientMutationId?: ?string,
};
export type TVShowEpisodeAddMutationVariables = {|
  input: TVShowEpisodeAddInput
|};
export type TVShowEpisodeAddMutationResponse = {|
  +TVShowEpisodeAdd: ?{|
    +tVShowEpisodeEdge: ?{|
      +node: ?{|
        +id: string
      |}
    |}
  |}
|};
export type TVShowEpisodeAddMutation = {|
  variables: TVShowEpisodeAddMutationVariables,
  response: TVShowEpisodeAddMutationResponse,
|};
*/


/*
mutation TVShowEpisodeAddMutation(
  $input: TVShowEpisodeAddInput!
) {
  TVShowEpisodeAdd(input: $input) {
    tVShowEpisodeEdge {
      node {
        id
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "TVShowEpisodeAddInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "TVShowEpisodeAdd",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "TVShowEpisodeAddInput!"
      }
    ],
    "concreteType": "TVShowEpisodeAddPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "tVShowEpisodeEdge",
        "storageKey": null,
        "args": null,
        "concreteType": "TVShowEpisodeEdge",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "TVShowEpisode",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "TVShowEpisodeAddMutation",
  "id": null,
  "text": "mutation TVShowEpisodeAddMutation(\n  $input: TVShowEpisodeAddInput!\n) {\n  TVShowEpisodeAdd(input: $input) {\n    tVShowEpisodeEdge {\n      node {\n        id\n      }\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "TVShowEpisodeAddMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "TVShowEpisodeAddMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'fa53f52633fcf7772d8c0003c572e6ec';
module.exports = node;



// WEBPACK FOOTER //
// src/mutations/__generated__/TVShowEpisodeAddMutation.graphql.js